import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WorkEffortService {
  constructor(private http: HttpClient) {}

  // Fetch work effort (schedule) for a specific content
  getWorkEffort(contentId: string): Observable<any> {
    return this.http.get(`/api/work-effort/${contentId}`);  // Replace with actual endpoint
  }

  // Create or update work effort (scheduling)
  createOrUpdateWorkEffort(workEffort: any): Observable<any> {
    return this.http.post('/api/work-effort', workEffort);  // Replace with actual endpoint
  }
  // Method to schedule or immediately publish the post
  schedulePost(contentId: string, workEffortTypeId: string, scheduledDate?: Date): Observable<any> {
    let workEffortData = {
      contentId: contentId,
      workEffortTypeId: workEffortTypeId,
      scheduledDate: scheduledDate || null
    };

    if (workEffortTypeId === 'scheduled') {
      // Handle scheduling logic
      return this.http.post('/api/work-effort/schedule', workEffortData);
    } else {
      // Handle immediate posting logic
      return this.http.post('/api/work-effort/instant', workEffortData);
    }
  }
}



